import { create } from "zustand";

export const USER_MENU_ONBOARDING = "user-menu";
export const HEADER_CONTEXT_ONBOARDING = "header-context";
export const CONTEXT_MODAL_ONBOARDING = "context-modal";
export const SCHEDULER_EDITOR_BOX_ONBOARDING = "scheduler-editor-box";
export const READ_ONLY_MODE_ONBOARDING = "read-only-mode";
export const ASSIGNATION_RECOMMENDATION_ONBOARDING = "assignation-recommendation";
export const SYSTEM_LABELS_ONBOARDING = "system-labels";
export const BUNDLE_SUBJECT_KEY_ONBOARDING = "bundle-subject-key";
export const BURGER_MENU_ONBOARDING = "burger-menu";
export const DELETE_SECTIONS_ONBOARDING = "delete-sections";
export const BOOKINGS_ONBOARDING = "bookings";

const DEPRECATED_ONBOARDINGS = [
  USER_MENU_ONBOARDING,
  HEADER_CONTEXT_ONBOARDING,
  CONTEXT_MODAL_ONBOARDING,
  SCHEDULER_EDITOR_BOX_ONBOARDING,
  READ_ONLY_MODE_ONBOARDING,
  ASSIGNATION_RECOMMENDATION_ONBOARDING,
  SYSTEM_LABELS_ONBOARDING,
  BUNDLE_SUBJECT_KEY_ONBOARDING,
  BURGER_MENU_ONBOARDING,
  DELETE_SECTIONS_ONBOARDING,
  BOOKINGS_ONBOARDING,
];

export type OnboardingType =
  | typeof USER_MENU_ONBOARDING
  | typeof HEADER_CONTEXT_ONBOARDING
  | typeof CONTEXT_MODAL_ONBOARDING
  | typeof SCHEDULER_EDITOR_BOX_ONBOARDING
  | typeof READ_ONLY_MODE_ONBOARDING
  | typeof ASSIGNATION_RECOMMENDATION_ONBOARDING
  | typeof SYSTEM_LABELS_ONBOARDING
  | typeof BUNDLE_SUBJECT_KEY_ONBOARDING
  | typeof BURGER_MENU_ONBOARDING
  | typeof DELETE_SECTIONS_ONBOARDING
  | typeof BOOKINGS_ONBOARDING;

type State = {
  isOnboardingOpen: boolean;
  visibleOnboardingType?: OnboardingType | null;
  onboardingsSeen?: OnboardingType[];
  showSurveyOnboardingModal: boolean;
};

const getLocalStorageOnboardings = (): OnboardingType[] => {
  const keys = Object.keys(localStorage).filter(key => key.startsWith("onboarding-"));

  return [...keys, ...DEPRECATED_ONBOARDINGS].map(
    key => key.replace("onboarding-", "") as OnboardingType,
  );
};

export const useOnboardingStore = create<State>(() => ({
  isOnboardingOpen: false,
  visibleOnboardingType: null,
  onboardingsSeen: getLocalStorageOnboardings(),
  showSurveyOnboardingModal: false,
}));

export const setShowSurveyOnboardingModal = (show: boolean) => {
  useOnboardingStore.setState({ showSurveyOnboardingModal: show });
};

export const isOnboardingSeen = (onboardingType: OnboardingType): boolean => {
  const seenOnboarding = localStorage.getItem(`onboarding-${onboardingType}`);
  const storeSeenOnboarding = useOnboardingStore
    .getState()
    .onboardingsSeen?.includes(onboardingType);

  return !!seenOnboarding || !!storeSeenOnboarding;
};

export const shouldShowHotspot = (onboardingType: OnboardingType): boolean => {
  const seenOnboarding = isOnboardingSeen(onboardingType);
  const store = useOnboardingStore.getState();

  return (
    (!seenOnboarding && !store.isOnboardingOpen) ||
    (store.isOnboardingOpen && store.visibleOnboardingType === onboardingType)
  );
};

export const setIsOnboardingOpen = (isOpen: boolean, type: OnboardingType) => {
  const isSeen = isOnboardingSeen(type);

  if (!isSeen) {
    localStorage.setItem(`onboarding-${type}`, "true");
  }

  useOnboardingStore.setState({
    isOnboardingOpen: isOpen,
    visibleOnboardingType: isOpen ? type : null,
    onboardingsSeen: [...useOnboardingStore.getState().onboardingsSeen, type],
  });
};

export const clearOnboardingLocalStorage = () => {
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith("onboarding-")) {
      localStorage.removeItem(key);
    }
  });
};
